var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoK(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "22px",
    height: "14px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(255, 255, 255)",
    d: "M20.045,14.000 C18.963,14.000 18.090,13.146 18.090,12.095 C18.090,12.006 18.097,11.921 18.109,11.837 L11.105,6.590 L3.865,12.497 C3.675,13.356 2.893,14.000 1.956,14.000 C0.876,14.000 -0.000,13.146 -0.000,12.095 C-0.000,11.044 0.876,10.189 1.956,10.189 C2.164,10.189 2.366,10.222 2.554,10.283 L10.318,4.051 C7.710,3.841 2.086,2.495 2.086,2.495 L2.086,-0.000 C2.086,-0.000 8.710,1.587 10.918,1.587 C13.188,1.587 19.999,-0.000 19.999,-0.000 L19.999,2.495 C19.999,2.495 14.510,3.772 11.747,4.032 L19.999,10.083 L19.999,10.191 L20.045,10.189 C21.123,10.189 22.000,11.044 22.000,12.095 C22.000,13.146 21.123,14.000 20.045,14.000 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoK);
export default __webpack_public_path__ + "static/media/ico-k.eddb9825bf3fd4f965b970bfe2457453.svg";
export { ForwardRef as ReactComponent };